import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m16.283 3.591-2.951 2.915a.75.75 0 1 1-1.054-1.068l2.95-2.914a4.432 4.432 0 0 1 3.115-1.274c1.165 0 2.285.457 3.113 1.274.41.405.735.885.957 1.415a4.322 4.322 0 0 1-.957 4.76l-5.575 5.504a4.42 4.42 0 0 1-1.43.944 4.45 4.45 0 0 1-4.796-.944.75.75 0 0 1 1.054-1.067 2.946 2.946 0 0 0 4.119 0l5.574-5.504c.27-.267.483-.582.628-.929a2.822 2.822 0 0 0-.628-3.112 2.93 2.93 0 0 0-2.06-.841c-.774 0-1.515.304-2.06.841Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m9.173 10.864-5.574 5.504a2.839 2.839 0 0 0-.849 2.02c0 .756.304 1.483.849 2.02a2.931 2.931 0 0 0 2.059.842c.774 0 1.514-.304 2.059-.841l2.509-2.478A.75.75 0 1 1 11.28 19l-2.51 2.476a4.431 4.431 0 0 1-3.113 1.274 4.431 4.431 0 0 1-3.113-1.274 4.34 4.34 0 0 1-1.295-3.088c0-1.16.467-2.27 1.295-3.087l5.574-5.504a4.43 4.43 0 0 1 3.113-1.274 4.43 4.43 0 0 1 3.113 1.274.75.75 0 1 1-1.054 1.067 2.93 2.93 0 0 0-2.059-.841 2.93 2.93 0 0 0-2.06.841Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function a(r, s) {
  return l(), o("svg", t, [...d]);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
